import classnames from 'classnames';
import Info from '@/components/Icons/Info';
import s from './BannerStatus.module.scss';

const BannerStatus: React.FC<{
  status: 'success' | 'error' | 'warning';
  label: string;
  indent?: boolean;
  className?: string;
}> = ({ className, indent, status, label }) => (
  <div
    className={classnames(
      indent && s.bannerIndent,
      status === 'error' && s.bannerError,
      status === 'warning' && s.bannerWarning,
      status === 'success' && s.bannerSuccess,
      className,
    )}
  >
    <Info
      size={16}
      weight="fill"
      color={
        (status === 'error' && 'var(--color-error')
          || (status === 'warning' && 'var(--color-warning')
          || 'var(--color-success)'
      }
    />
    {label}
  </div>
);

export default BannerStatus;
